import { jsx as o, jsxs as r } from "react/jsx-runtime";
import { useMemo as p, useState as m, useEffect as d } from "react";
import { LabeledJsonInput as l } from "../shared/labeled-json-input/LabeledJsonInput.component.js";
import { c as _ } from "../index-C3-ZVs5E.js";
import '../assets/FlowRunLogs.css';const u = "_container_3uwxa_2", v = "_logHeader_3uwxa_9", x = "_name_3uwxa_15", g = "_type_3uwxa_20", y = "_negative_3uwxa_25", h = "_positive_3uwxa_28", a = {
  container: u,
  logHeader: v,
  name: x,
  type: g,
  negative: y,
  positive: h
}, w = () => {
  throw new Error("Function not implemented.");
}, N = ({ flowRunLog: e }) => {
  const t = JSON.parse(e.content ?? "{}"), s = "name" in t ? t.name : "", n = "type" in t ? t.type : "";
  return /* @__PURE__ */ o(
    l,
    {
      id: e.id,
      labelText: p(
        () => /* @__PURE__ */ r("div", { className: a.logHeader, children: [
          s && /* @__PURE__ */ o("span", { className: a.name, children: s }),
          n && /* @__PURE__ */ o(
            "span",
            {
              className: _(a.type, {
                [a.negative]: n === "step-skipped" || n === "step-discontinued",
                [a.positive]: n === "step-completed"
              }),
              children: n
            }
          ),
          new Date(e.createdAt ?? "").toLocaleDateString() + " " + new Date(e.createdAt ?? "").toLocaleTimeString()
        ] }),
        [e.createdAt, s, n]
      ),
      error: null,
      initialContent: t,
      readOnly: !0,
      onChange: w
    },
    e.id
  );
}, F = ({
  queryFlowRunLogs: e,
  flowRunId: t,
  fetchKey: s
}) => {
  const [n, c] = m([]);
  return d(() => {
    e(t).then((i) => {
      c(i);
    });
  }, [e, t, s]), /* @__PURE__ */ o("div", { className: a.container, children: n.map((i) => /* @__PURE__ */ o(N, { flowRunLog: i }, i.id)) });
};
export {
  N as FlowRunLog,
  F as FlowRunLogs
};
